import { HttpBaseApiWrapper } from 'service/HttpBaseApiWrapper'

import { ITransportPlan2 } from '../service/TransportPlan2'

export class TransportPlanService {
  http: HttpBaseApiWrapper
  constructor(http: HttpBaseApiWrapper) {
    this.http = http
  }
  get(shipmentId: string): Promise<ITransportPlan2> {
    return this.http.get(`/shipments/${shipmentId}/transportScheme`)
  }
  getMany(ids: string[]): Promise<Record<string, ITransportPlan2>> {
    return this.http.get(`/shipments/transportSchemes?shipmentIds=${ids.join(',')}`)
  }
}
